import { useQuery } from "@tanstack/react-query";
import { Alert, Badge, Card } from "react-bootstrap";

import { getAgentStatus, getAgentLogs } from "../services/agent.service";
import Loader from "../ui/Spinner.component";
import ErrorPage from "../ui/ErrorPage.component";

function AgentStatus() {
  const { data: status, isLoading: sLoading, error: sError } = useQuery({
    queryKey: ["agentStatus"],
    queryFn: getAgentStatus,
    refetchInterval: 30_000,    // poll every 30s
  });

  const { data: logs, isLoading: lLoading, error: lError } = useQuery({
    queryKey: ["agentLogs"],
    queryFn: () => getAgentLogs(300),
    refetchInterval: 30_000,
  });

  if (sLoading || lLoading) return <Loader />;
  if (sError || lError)
    return <ErrorPage errorCode="500" description="Could not reach the agent endpoint." />;

  const active = status?.systemd?.active;
  const stateLabel = status?.systemd?.state || "unknown";
  const since = status?.systemd?.since || "n/a";
  const subState = status?.systemd?.sub_state || "";
  const lastLine = status?.log?.last_line || "—";
  const logMtime = status?.log?.mtime ? new Date(status.log.mtime).toLocaleString() : "n/a";

  return (
    <div className="container mt-3">
      <h3>Trading Agent</h3>
      <hr />

      {/* === Status card === */}
      <Card className="mb-3">
        <Card.Body>
          <Card.Title>
            Status:{" "}
            <Badge bg={active ? "success" : "danger"}>
              {active ? "RUNNING" : stateLabel.toUpperCase()}
            </Badge>{" "}
            {subState && <small className="text-muted">({subState})</small>}
          </Card.Title>
          <div><strong>systemd unit:</strong> {status?.service}</div>
          <div><strong>Active since:</strong> {since}</div>
          <div><strong>Log file:</strong> <code>{status?.log_file}</code></div>
          <div><strong>Last log mtime:</strong> {logMtime}</div>
          <div className="mt-2">
            <strong>Last log line:</strong>
            <pre className="bg-light p-2 mb-0" style={{ fontSize: "0.85em", whiteSpace: "pre-wrap" }}>
              {lastLine}
            </pre>
          </div>
          {status?.systemd?.error && (
            <Alert variant="warning" className="mt-2 mb-0">
              systemd error: {status.systemd.error}
            </Alert>
          )}
        </Card.Body>
      </Card>

      {/* === Recent logs === */}
      <Card>
        <Card.Body>
          <Card.Title>Recent log (last {logs?.lines?.length || 0} lines)</Card.Title>
          <pre
            className="bg-dark text-light p-3"
            style={{
              fontSize: "0.8em",
              maxHeight: "60vh",
              overflowY: "scroll",
              whiteSpace: "pre-wrap",
            }}
          >
            {(logs?.lines || []).join("\n")}
          </pre>
          <small className="text-muted">
            Auto-refreshes every 30s. Path: <code>{logs?.path}</code>
          </small>
        </Card.Body>
      </Card>
    </div>
  );
}

export default AgentStatus;
